module.exports = __webpack_public_path__ + "img/AMDicon-logo.d87aeb0d.png";